// import * as R from 'ramda'

import arraysEqualIgnoringOrder from './arraysEqualIgnoringOrder'

// if invalid
// will throw on js if unlogged
// fix: useControllableReducer: The useSelect component is changing an uncontrolled prop to be controlled: selectedValues

export default function currentUserAttributesValid (userObject) {
  const object_valid = typeof userObject === 'object' && userObject !== null
  if (!object_valid) { return false }

  const actualFields = Object.keys(userObject)
  const requiredFields = ['email', 'first_name', 'last_name', 'salutation', 'country', 'state', 'city', 'address_line', 'zipcode', 'phone']

  return arraysEqualIgnoringOrder(requiredFields, actualFields)
}
